/* eslint-disable no-restricted-imports */
import { DateTime } from "@bps/date-time";
import {
  DatePickerArrows as CoreDatePickerArrows,
  DatePickerArrowProps
} from "@bps/fluent-ui";

export const DatePickerArrows: React.FunctionComponent<
  DatePickerArrowProps
> = ({ calendarProps, ...props }) => (
  <CoreDatePickerArrows
    {...props}
    calendarProps={{
      today: DateTime.jsDateNow(),
      ...calendarProps
    }}
  />
);
